export default __webpack_public_path__ + "static/drag-dark-mode-283d4b844118c7a3d9f713df79c0fe32.mp4";